import React, { useState } from 'react'
import { useProperty } from '../../../PropertyContext';
import { fetchTerms, saveTerms } from '../../../Redux/Slices/termsSlice';
import { useDispatch } from 'react-redux';
import swal from "sweetalert";

export const AddTermsAndCon = ({ termsList }) => {
    const { selectedProperty } = useProperty();
    const dispatch = useDispatch();

    const [description, setDescription] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!description.trim()) {
            swal("Warning!", "Please enter description", "warning");
            return;
        }

        // ✅ Safe SortOrder Logic (Professional Way)
        const sortOrder =
            termsList && termsList.length > 0
                ? Math.max(...termsList.map(item => item.SortOrder)) + 1
                : 0;

        const postData = {
            PropertyID: selectedProperty.PropertyID,
            Description: description,
            SortOrder: sortOrder
        };

        try {
            const resultAction = await dispatch(saveTerms(postData));

            if (saveTerms.fulfilled.match(resultAction)) {
                swal("Success!", "Terms & Condition Added Successfully", "success");

                dispatch(fetchTerms(selectedProperty.PropertyID));

                setDescription("");

                // ✅ Close Modal (Bootstrap 5 way)
                const modalElement = document.getElementById("Add-Terms-Condition");
                const modalInstance = window.bootstrap.Modal.getInstance(modalElement);
                modalInstance.hide();
                
            } else {
                swal("Error!", "Something went wrong", "error");
            }

        } catch (error) {
            swal("Error!", "Failed to save data", "error");
        }
    };


    return (
        <>
            <form onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-md-12">
                        <textarea
                            rows={2}
                            className="form-control"
                            placeholder="Enter Description"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                        />
                    </div>
                    <div className="col-md-12">
                        <div className="text-end mt-3">
                            <button type="submit" className="btn btn-primary">
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </>
    )
}
